/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { subscribeControllerAdminCancelSubscription } from '../fn/subscribe/subscribe-controller-admin-cancel-subscription';
import { SubscribeControllerAdminCancelSubscription$Params } from '../fn/subscribe/subscribe-controller-admin-cancel-subscription';
import { subscribeControllerAdminCancelSubscriptionForce } from '../fn/subscribe/subscribe-controller-admin-cancel-subscription-force';
import { SubscribeControllerAdminCancelSubscriptionForce$Params } from '../fn/subscribe/subscribe-controller-admin-cancel-subscription-force';
import { subscribeControllerCancelSubscription } from '../fn/subscribe/subscribe-controller-cancel-subscription';
import { SubscribeControllerCancelSubscription$Params } from '../fn/subscribe/subscribe-controller-cancel-subscription';
import { subscribeControllerChangeBillingPayment } from '../fn/subscribe/subscribe-controller-change-billing-payment';
import { SubscribeControllerChangeBillingPayment$Params } from '../fn/subscribe/subscribe-controller-change-billing-payment';
import { subscribeControllerChangeSubscription } from '../fn/subscribe/subscribe-controller-change-subscription';
import { SubscribeControllerChangeSubscription$Params } from '../fn/subscribe/subscribe-controller-change-subscription';
import { subscribeControllerCreate } from '../fn/subscribe/subscribe-controller-create';
import { SubscribeControllerCreate$Params } from '../fn/subscribe/subscribe-controller-create';
import { subscribeControllerCreateExperience } from '../fn/subscribe/subscribe-controller-create-experience';
import { SubscribeControllerCreateExperience$Params } from '../fn/subscribe/subscribe-controller-create-experience';
import { subscribeControllerFindById } from '../fn/subscribe/subscribe-controller-find-by-id';
import { SubscribeControllerFindById$Params } from '../fn/subscribe/subscribe-controller-find-by-id';
import { subscribeControllerFindReserveSubscription } from '../fn/subscribe/subscribe-controller-find-reserve-subscription';
import { SubscribeControllerFindReserveSubscription$Params } from '../fn/subscribe/subscribe-controller-find-reserve-subscription';
import { subscribeControllerSearchOffset } from '../fn/subscribe/subscribe-controller-search-offset';
import { SubscribeControllerSearchOffset$Params } from '../fn/subscribe/subscribe-controller-search-offset';
import { subscribeControllerTriggerCronJob } from '../fn/subscribe/subscribe-controller-trigger-cron-job';
import { SubscribeControllerTriggerCronJob$Params } from '../fn/subscribe/subscribe-controller-trigger-cron-job';
import { SubscriptionDto } from '../models/subscription-dto';

@Injectable({ providedIn: 'root' })
export class SubscribeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `subscribeControllerTriggerCronJob()` */
  static readonly SubscribeControllerTriggerCronJobPath = '/api/subscribe/admin/cron';

  /**
   * 구독 크론 잡 트리거 (관리자용).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribeControllerTriggerCronJob()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeControllerTriggerCronJob$Response(params?: SubscribeControllerTriggerCronJob$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return subscribeControllerTriggerCronJob(this.http, this.rootUrl, params, context);
  }

  /**
   * 구독 크론 잡 트리거 (관리자용).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribeControllerTriggerCronJob$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeControllerTriggerCronJob(params?: SubscribeControllerTriggerCronJob$Params, context?: HttpContext): Observable<void> {
    return this.subscribeControllerTriggerCronJob$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `subscribeControllerSearchOffset()` */
  static readonly SubscribeControllerSearchOffsetPath = '/api/subscribe/admin/all';

  /**
   * 모든 구독 정보 조회 (관리자용).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribeControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeControllerSearchOffset$Response(params: SubscribeControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return subscribeControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 구독 정보 조회 (관리자용).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribeControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeControllerSearchOffset(params: SubscribeControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.subscribeControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `subscribeControllerFindReserveSubscription()` */
  static readonly SubscribeControllerFindReserveSubscriptionPath = '/api/subscribe/reserve';

  /**
   * 예약된 구독 정보 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribeControllerFindReserveSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeControllerFindReserveSubscription$Response(params: SubscribeControllerFindReserveSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
    return subscribeControllerFindReserveSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * 예약된 구독 정보 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribeControllerFindReserveSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeControllerFindReserveSubscription(params: SubscribeControllerFindReserveSubscription$Params, context?: HttpContext): Observable<SubscriptionDto> {
    return this.subscribeControllerFindReserveSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionDto>): SubscriptionDto => r.body)
    );
  }

  /** Path part for operation `subscribeControllerFindById()` */
  static readonly SubscribeControllerFindByIdPath = '/api/subscribe/{id}';

  /**
   * 구독 정보 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribeControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeControllerFindById$Response(params: SubscribeControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
    return subscribeControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 구독 정보 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribeControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeControllerFindById(params: SubscribeControllerFindById$Params, context?: HttpContext): Observable<SubscriptionDto> {
    return this.subscribeControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionDto>): SubscriptionDto => r.body)
    );
  }

  /** Path part for operation `subscribeControllerCreate()` */
  static readonly SubscribeControllerCreatePath = '/api/subscribe';

  /**
   * 구독.
   *
   * 결제 후 구독을 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribeControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscribeControllerCreate$Response(params: SubscribeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
    return subscribeControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 구독.
   *
   * 결제 후 구독을 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribeControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscribeControllerCreate(params: SubscribeControllerCreate$Params, context?: HttpContext): Observable<SubscriptionDto> {
    return this.subscribeControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionDto>): SubscriptionDto => r.body)
    );
  }

  /** Path part for operation `subscribeControllerCreateExperience()` */
  static readonly SubscribeControllerCreateExperiencePath = '/api/subscribe/experience';

  /**
   * 체험권 구독 생성 (관리자용).
   *
   * 체험권 구독을 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribeControllerCreateExperience()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscribeControllerCreateExperience$Response(params: SubscribeControllerCreateExperience$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
    return subscribeControllerCreateExperience(this.http, this.rootUrl, params, context);
  }

  /**
   * 체험권 구독 생성 (관리자용).
   *
   * 체험권 구독을 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribeControllerCreateExperience$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscribeControllerCreateExperience(params: SubscribeControllerCreateExperience$Params, context?: HttpContext): Observable<SubscriptionDto> {
    return this.subscribeControllerCreateExperience$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionDto>): SubscriptionDto => r.body)
    );
  }

  /** Path part for operation `subscribeControllerChangeBillingPayment()` */
  static readonly SubscribeControllerChangeBillingPaymentPath = '/api/subscribe/change-billing';

  /**
   * 결제 정보 변경.
   *
   * 결제 정보를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribeControllerChangeBillingPayment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscribeControllerChangeBillingPayment$Response(params: SubscribeControllerChangeBillingPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
    return subscribeControllerChangeBillingPayment(this.http, this.rootUrl, params, context);
  }

  /**
   * 결제 정보 변경.
   *
   * 결제 정보를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribeControllerChangeBillingPayment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscribeControllerChangeBillingPayment(params: SubscribeControllerChangeBillingPayment$Params, context?: HttpContext): Observable<SubscriptionDto> {
    return this.subscribeControllerChangeBillingPayment$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionDto>): SubscriptionDto => r.body)
    );
  }

  /** Path part for operation `subscribeControllerChangeSubscription()` */
  static readonly SubscribeControllerChangeSubscriptionPath = '/api/subscribe/change';

  /**
   * 구독 플랜 변경.
   *
   * 구독 플랜을 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribeControllerChangeSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscribeControllerChangeSubscription$Response(params: SubscribeControllerChangeSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
    return subscribeControllerChangeSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * 구독 플랜 변경.
   *
   * 구독 플랜을 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribeControllerChangeSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscribeControllerChangeSubscription(params: SubscribeControllerChangeSubscription$Params, context?: HttpContext): Observable<SubscriptionDto> {
    return this.subscribeControllerChangeSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionDto>): SubscriptionDto => r.body)
    );
  }

  /** Path part for operation `subscribeControllerCancelSubscription()` */
  static readonly SubscribeControllerCancelSubscriptionPath = '/api/subscribe/cancel';

  /**
   * 구독 취소.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribeControllerCancelSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeControllerCancelSubscription$Response(params: SubscribeControllerCancelSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return subscribeControllerCancelSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * 구독 취소.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribeControllerCancelSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeControllerCancelSubscription(params: SubscribeControllerCancelSubscription$Params, context?: HttpContext): Observable<void> {
    return this.subscribeControllerCancelSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `subscribeControllerAdminCancelSubscription()` */
  static readonly SubscribeControllerAdminCancelSubscriptionPath = '/api/subscribe/admin/cancel';

  /**
   * 구독 취소 (관리자용).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribeControllerAdminCancelSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeControllerAdminCancelSubscription$Response(params: SubscribeControllerAdminCancelSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return subscribeControllerAdminCancelSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * 구독 취소 (관리자용).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribeControllerAdminCancelSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeControllerAdminCancelSubscription(params: SubscribeControllerAdminCancelSubscription$Params, context?: HttpContext): Observable<void> {
    return this.subscribeControllerAdminCancelSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `subscribeControllerAdminCancelSubscriptionForce()` */
  static readonly SubscribeControllerAdminCancelSubscriptionForcePath = '/api/subscribe/admin/cancel-force';

  /**
   * 구독 취소 (관리자용) (즉시 종료).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribeControllerAdminCancelSubscriptionForce()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeControllerAdminCancelSubscriptionForce$Response(params: SubscribeControllerAdminCancelSubscriptionForce$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return subscribeControllerAdminCancelSubscriptionForce(this.http, this.rootUrl, params, context);
  }

  /**
   * 구독 취소 (관리자용) (즉시 종료).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribeControllerAdminCancelSubscriptionForce$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeControllerAdminCancelSubscriptionForce(params: SubscribeControllerAdminCancelSubscriptionForce$Params, context?: HttpContext): Observable<void> {
    return this.subscribeControllerAdminCancelSubscriptionForce$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
